import { FunctionComponent } from 'react'

import Header from '../../../shared/components/Header'
import Sidebar from '../../../shared/components/Sidebar'
import { Container, Body } from './styles'

const BasePage: FunctionComponent = ({ children }) => {
  return (
    <Container>
      <Header />
      <Body>
        <Sidebar />
        {children}
      </Body>
    </Container>
  )
}

export default BasePage
